import 'reflect-metadata'
import {injectable} from 'inversify'
import {makeAutoObservable, observable, action} from 'mobx'
import {error} from 'dna-common'
import {storage} from '@/services/storage'
import {ROUTES} from '@/router/routes'
import {SIGNUP_STORAGE_KEYS} from '../constants'
import {validateRefCode} from '../api'
import {getRouterStore} from '@/router/utils'
import {IValidateRefCodeStore} from '~/code/pages/signUp'

@injectable()
export class ValidateRefCodeStore implements IValidateRefCodeStore {
    isValid: boolean = false
    isLoading: boolean = true
    validRef: string

    constructor() {
        makeAutoObservable(this, {
            isValid: observable,
            isLoading: observable,
            validRef: observable,

            validateRefCode: action.bound,
            showMessage: action.bound
        })
    }

    validateRefCode = async (ref: string) => {
        try {
            this.isLoading = true
            const {result, error} = await validateRefCode(ref)

            if (error) {
                this.isValid = false
                return
            }

            if (result) {
                this.isValid = true
                this.validRef = ref
                storage.set(SIGNUP_STORAGE_KEYS.REF_CODE, ref)

                getRouterStore().push(ROUTES.signUpValidateEmail)
            }
        } catch (err) {
            error(err?.message || err)
        } finally {
            this.isLoading = false
        }
    }

    showMessage = () => {
        this.isValid = false
        this.isLoading = false
    }

    goToLoginPage = () => {
        getRouterStore().push(ROUTES.login)
    }
}
